import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/settings/${ view }.vue`);
}


const Index = loadView( 'Index' );

const settingsRoutes = [
    {
        path: 'settings',
        name: 'api.settings.getList',
        component: Index,
        meta: {
            middleware: permission
        }
    }
];

export default settingsRoutes;
